export const invalidKeys = [
  {
    key: "duplicate_ssn",
    title: "Duplicate SSNs"
  },
  {
    key: "invalid_email",
    title: "Incorrect emails"
  },
  {
    key: "invalid_phone",
    title: "Incorrect phones"
  },
  {
    key: "wrong_move_in",
    title: "Violate move in date requirements"
  },
  {
    key: "wrong_lease_end",
    title: "Violate lease end date requirements"
  },
  {
    key: "wrong_rent_amount",
    title: "Violate rent amount requirements"
  },
  {
    key: "duplicate_phone",
    title: "Phone already exists"
  },
  {
    key: "duplicate_email",
    title: "Email already exists"
  },
  {
    key: "address_change",
    title: "Change in address"
  },
  {
    key: "no_phone",
    title: "No phone provided"
  },
  {
    key: "no_email",
    title: "No email provided"
  },
  {
    key: "wrong_dob",
    title: "Violate data of birth requirements"
  },
  {
    key: "wrong_lease_start",
    title: "Violate lease start requirements"
  },
  {
    key: "wrong_move_out",
    title: "Violate move out date requirements"
  },
  {
    key: "wrong_ssn",
    title: "Invalid SSNs"
  }
];

export const batchUploadCrumbs = [
  {
    title: "Rent reporting",
    href: "/rent-reporting"
  },
  {
    title: "Upload CSV",
    href: "/rent-reporting/upload"
  }
];

export const getTooltipContent = (key: string) => {
  switch (key) {
    case "duplicate_ssn":
      return {
        title: "Duplicate SSNs",
        content: "Duplicate SSNs within the file"
      };
    case "invalid_email":
      return {
        title: "Incorrect emails",
        content: "Email must be in the valid format. E.g. example@example.com"
      };
    case "invalid_phone":
      return {
        title: "Incorrect phones",
        content: "Phone must be in the valid format. E.g. +1234567890"
      };
    case "wrong_move_in":
      return {
        title: "Violate move in date requirements",
        content: "Move in date should be less than 80 years"
      };
    case "wrong_lease_end":
      return {
        title: "Violate lease end date requirements",
        content: "Lease end date should be within 2 years"
      };
    case "wrong_rent_amount":
      return {
        title: "Violate rent amount requirements",
        content: "Rent amount should be number within range 50 - 8000"
      };
    case "duplicate_phone":
      return {
        title: "Phone already exists",
        content: "Phone is already used in the system"
      };
    case "duplicate_email":
      return {
        title: "Email already exists",
        content: "Email is already used in the system"
      };
    case "address_change":
      return {
        title: "Change in address",
        content: "Change in address is not supported yet"
      };
    case "no_phone":
      return {
        title: "No phone provided",
        content: "Phone is required"
      };
    case "no_email":
      return {
        title: "No email provided",
        content: "Email is required"
      };
    case "wrong_dob":
      return {
        // TODO: likely wrong
        title: "Violate data of birth requirements",
        content: "Date of birth should be at least 18 years old"
      };
    case "wrong_lease_start":
      return {
        // TODO: likely wrong
        title: "Violate lease start requirements",
        content: "Lease start date should be within 2 years"
      };
    case "wrong_move_out":
      // TODO: likely wrong
      return {
        title: "Violate move out date requirements",
        content: "Move out date should be within 2 years"
      };
    case "wrong_ssn":
      return {
        title: "Invalid SSNs",
        content: "SSN should be in the valid format. E.g. 123456789"
      };
    default:
      return {
        title: "",
        content: ""
      };
  }
};
